import React from 'react'
import { IProps } from './index'
import { IProps as ISecondaryNavSection, SecondaryNavSection } from '../SecondaryNavSection'
import { Select } from 'marketing-site/src/library/elements/Select'
import { useRouter } from 'next/router'
import classnames from 'classnames'
import { useIntersectionContext } from 'marketing-site/src/components/context/IntersectionContext'
import { useVerticalObserver } from 'marketing-site/src/library/hooks/use-vertical-observer'

import { SecondaryNav as SecondaryNavDefault } from './component'
import { BrandOptions, useBrand } from '../../providers/brandProvider'

export const SecondaryNav = (props: IProps): React.ReactElement => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <SecondaryNavDefault {...props} />
  }
  return <SecondaryNavLegacy {...props} />
}

const SecondaryNavLegacy: React.FC<IProps> = ({ navSections, menuDirection = 'vertical' }) => {
  const router = useRouter()
  const { navTitle, currentItem, itemRefs } = useIntersectionContext()
  useVerticalObserver()

  const urlWithoutQuery = router.asPath.split('?')[0]

  function extractSelectOptions(sections: ISecondaryNavSection[]) {
    return sections.map((section: ISecondaryNavSection) => {
      const isSelected = urlWithoutQuery === section.url
      return {
        name: section.title,
        value: section.url || '',
        isSelected,
      }
    })
  }

  const secondaryNavFullListClasses = classnames('secondary-nav__full-list', {
    'secondary-nav__full-list--horizontal': menuDirection === 'horizontal',
  })

  const secondaryNavItemClasses = classnames('secondary-nav__item', {
    'secondary-nav__item--horizontal': menuDirection === 'horizontal',
  })

  return (
    <>
      <div className="secondary-nav__select-list">
        <Select
          options={extractSelectOptions(navSections)}
          id="menu-select"
          onChange={(event) => (window.location.href = event.target.value)}
        />
      </div>
      <ul className={secondaryNavFullListClasses}>
        {navTitle && menuDirection === 'horizontal' && (
          <li className="secondary-nav__item secondary-nav__nav-title">{navTitle}:</li>
        )}
        {navSections.map((navSection: ISecondaryNavSection) => {
          const { title } = navSection
          const isSelected =
            urlWithoutQuery === navSection.url || navSection.url === `#${currentItem}`

          return (
            <li key={title} className={secondaryNavItemClasses}>
              <SecondaryNavSection {...navSection} isOpen={isSelected} />
            </li>
          )
        })}
      </ul>
      <style jsx>{`
        .secondary-nav {
          &__select-list {
            display: block;
          }
          &__full-list {
            display: none;
          }
          &__item {
            padding-bottom: 2em;
          }
        }

        @include media-query(tablet) {
          .secondary-nav {
            &__select-list {
              display: none;
            }
            &__full-list {
              display: block;
              &--horizontal {
                max-width: 1290px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
              }
            }
            &__item {
              &--horizontal {
                padding: 1rem 0;
                flex-basis: auto;
              }
            }
            &__nav-title {
              text-align: center;
              flex-basis: max-content;
              padding: 1rem 3% 1rem 0;
            }
          }
        }

        @include media-query(desktop) {
          .secondary-nav {
            &__full-list {
              &--horizontal {
                justify-content: stretch;
              }
            }
            &__item {
              &--horizontal {
                padding: 1rem 0;
                flex-basis: ${100 / (itemRefs.length + 1) - 3}%;
              }
            }
          }
        }
      `}</style>
    </>
  )
}
